import React from 'react';
import './UserData.scss'

const UserData = (prop) => {

  return(
    <div className="user-info">
      <div className="user-info__wrap">
        <h3 className="user-info__title">{prop.name} {prop.lastName}</h3>
        <div className="user-info__group">
          <span className="user-info__label"><i className="ti-email" />E-mail address:</span>
          <span className="user-info__content user-info__content-email">{prop.email}</span>
        </div>
        <div className="user-info__group">
          <span className="user-info__label"><i className="ti-mobile" />Phone number:</span>
          <span className="user-info__content">{prop.phone}</span>
        </div>
      </div>
    </div>
  )
};

export default UserData;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/UserData.js